import { defineStore } from "pinia";

export const useCustomerStore = defineStore("customer", {
	state: () => {
		return {
			customerData: null,
			sellerData: null,
			isLoggedIn: false,
		};
	},
	actions: {
		setCustomerData(customerData) {
			this.customerData = customerData;
			if (customerData) {
				this.isLoggedIn = true;
			} else {
				this.isLoggedIn = false;
			}
		},
		setSellerData(sellerData) {
			this.sellerData = sellerData;
		},
	},
});
